import { createSlice as createReduxSlice } from '@reduxjs/toolkit';

import type { AsyncThunkActionDefinition, ControllerConfig, PageReducerState } from './types';

export default function createSlice<TState>(
  input: ControllerConfig<TState>,
  asyncThunkActionDefinitions: AsyncThunkActionDefinition[],
) {
  const initialState: PageReducerState<TState> = {
    pageState: {
      loaded: false,
      fetching: false,
      isProcessing: false,
      location: null,
      params: null,
      queryParams: null,
      navigateTo: null,
      pendingAction: null,
      errorOnLoad: false,
    },
    data: input.state,
  };

  return createReduxSlice({
    name: input.name,
    initialState,
    reducers: {
      clearNavigateTo: (state) => {
        state.pageState.navigateTo = null;
      },
    },
    extraReducers: (builder) => {
      asyncThunkActionDefinitions.forEach((asyncThunkActionDefinition) => {
        builder.addCase(
          asyncThunkActionDefinition.asyncThunk.pending,
          asyncThunkActionDefinition.pending,
        );

        if (asyncThunkActionDefinition.onSuccess) {
          builder.addCase(
            asyncThunkActionDefinition.asyncThunk.fulfilled,
            asyncThunkActionDefinition.onSuccess,
          );
        }

        if (asyncThunkActionDefinition.onError) {
          builder.addCase(
            asyncThunkActionDefinition.asyncThunk.rejected,
            asyncThunkActionDefinition.onError,
          );
        }
      });
    },
  });
}
